import { graphql } from "@/lib/gql/__generated__";

export const RESERVATION_DETAIL_CANCEL_FEE_CHARGE_FOR_MANAGEMENT_RESERVATION_ITEM_DETAIL_MUTATION = graphql(
	/* GraphQL */ `
		mutation ReservationDetailCancelFeeChargeForManagementReservationItemDetail(
			$input: ReservationCancelFeeChargeInput!
		) {
			reservationDetailCancelFeeCharge(input: $input) {
				reservationDetail {
					canChargeCancelFee
					willCancelFeeChargePrice
					canCancel
					canRefund
					canUpdate
					statusReservation
					totalGuestCharge
				}
				userErrors
			}
		}
	`,
);
